import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UmlService } from '../../services/uml.service';

@Component({
  selector: 'app-input-uml',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './input-uml.component.html',
  styleUrl: './input-uml.component.scss',
})
export class InputUmlComponent {
  private _umlService = inject(UmlService);
  javaText: string = '';

  updateCode(): void {
    this._umlService.transform(this.javaText);
  }
}
